import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { otherDeductionsDetailInputList1 } from '../../../../common/data';
import DetailTitleSection from '../../../../components/DetailTitleSection';
import DetailButtonSection from '../../../../components/DetailButtonSection';
import ItemTitleSection from '../../../../components/ItemTitleSection';
import Typography from '../../../../components/common/Typography';
import Radio from '../../../../components/common/Radio';
import Button from '../../../../components/common/Button';
import {
  handleAddButton,
  handleChange,
  handleDeleteButton,
  isValidate,
  renderField,
  renderField01,
} from '../util';
import SlideRightDialog from '../../../../components/common/SlideRightDialog';
import { getOtherDeductionsData1, saveOtherDeductionsData } from '../otherDeductionsSlice';
import { getBankList } from '../../../common/commonSlice';
import { getAlertMessageFunction, magamCertifyCheck } from '../../../../common/Util';

// 연금저축
const Type1 = ({ isOpen, onClose }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation('deductions/other');
  const { t: tCommon } = useTranslation('common');
  const { s11_1Data, detailReload } = useSelector(state => state.otherDeductions);
  const { bankList, isMagam, isCertify } = useSelector(state => state.common);
  const inputFields = otherDeductionsDetailInputList1(t);
  const [dataList, setDataList] = useState([]);
  const [htm177, sethtm177] = useState('');
  const initData = {
    htmSeq: '',
    htmFlag: 'Y',
    htmKFlag: '2',
    htmPDFFlag: '',
    htmType: '1',
    htm001: '',
    htm002: '',
    htm003: '',
    htm004: '',
    htm010: '',
  };
  useEffect(() => {
    if (isOpen && bankList.length === 0) {
      dispatch(getBankList());
    }
  }, [bankList]);

  useEffect(() => {
    //초기는 메인에서 받는다. 삭제, 저장할때만 다시받음
    if (detailReload != -1) {
      dispatch(getOtherDeductionsData1());
    }
  }, [detailReload]);

  useEffect(() => {
    if (isOpen) {
      const { htm177, list } = s11_1Data;
      sethtm177(htm177);
      const formattedData = list
        ?.map(item => {
          return {
            htmSeq: item.htmSeq,
            htmFlag: item.htmFlag?.trim(),
            htmKFlag: item.htmKFlag,
            htmPDFFlag: item.htmPDFFlag || '',
            htmType: item.htmType || '',
            htm001: item.htm001 || '',
            htm002: item.htm002 || '',
            htm003: item.htm003 || '',
            htm004: item.htm004 || '',
            htm010: item.htm010 || '',
          };
        })
        .sort((a, b) => {
          // htmSeq를 순서대로 정렬
          return Number(a.htmSeq) - Number(b.htmSeq);
        });
      setDataList(formattedData);
    }
  }, [s11_1Data, isOpen]);

  const handleSave = async () => {
    if (!magamCertifyCheck(isMagam, isCertify)) {
      return;
    }

    const alertMessage = getAlertMessageFunction();
    if (!isValidate(dataList, t)) {
      return;
    }

    let formData = dataList.map(item => {
      return {
        ...item,
        htm177: htm177,
      };
    });

    try {
      const resultAction = await dispatch(saveOtherDeductionsData({ formData })).unwrap();

      if (resultAction.resultCode === 'OK') {
        alertMessage(tCommon('alertMessage.saveSuccess'), 'success');
        onClose();
      } else {
        alertMessage(tCommon('alertMessage.saveFail'), 'error');
      }
    } catch (error) {
      alertMessage(tCommon('alertMessage.saveFail'), 'error');
      console.error('저장 중 오류 발생: ', error);
    }
  };

  return (
    <SlideRightDialog isOpen={isOpen} onClose={onClose}>
      <div className="displayFlexColumn" style={{ gap: '24px' }}>
        <DetailTitleSection title={`${t('detail.type1.title')}`} />

        <Typography variant="body2Medium">{t('detail.type1.radioTitle1')}</Typography>
        <div className="displayFlex" style={{ gap: '40px', justifyContent: 'flex-end' }}>
          <Radio
            label={tCommon('radioGroup.yes')}
            size="medium"
            value="1"
            name="htm177"
            checked={htm177 === '1'}
            onChange={e => sethtm177(e.target.value)}
          />
          <Radio
            label={tCommon('radioGroup.no')}
            size="medium"
            value="2"
            name="htm177"
            checked={htm177 == '' || htm177 == '2'}
            onChange={e => sethtm177(e.target.value)}
          />
        </div>

        {dataList?.length > 0 &&
          dataList?.map((data, index) => {
            //국세청자료
            let disabled = data?.htmType == '1' && data?.htmPDFFlag == '2' && data?.htmKFlag == '1';
            return (
              <div key={index} className="displayFlexColumn" style={{ gap: '10px' }}>
                <ItemTitleSection
                  title={`${t('detail.type1.title')}${index + 1}`}
                  buttonIcon={!disabled}
                  handleDeleteButton={() => {
                    if (!magamCertifyCheck(isMagam, isCertify)) {
                      return;
                    }
                    handleDeleteButton(
                      index,
                      setDataList,
                      tCommon,
                      dispatch,
                      dataList,
                      data.htmFlag,
                    );
                  }}
                />

                <div className="displayFlexColumn" style={{ gap: '16px' }}>
                  {inputFields.map(field => (
                    <div key={field.key}>
                      {renderField01(
                        field,
                        data[field.key],
                        value => handleChange(index, field.key, value, setDataList, dispatch),
                        '1',
                        bankList,
                        disabled,
                        data,
                      )}
                    </div>
                  ))}
                </div>
              </div>
            );
          })}

        <Button
          value={t('detail.type1.addButton')}
          style={{ width: '100%' }}
          addButton
          color="sub"
          onClick={() => {
            if (!magamCertifyCheck(isMagam, isCertify)) {
              return;
            }
            handleAddButton(setDataList, initData);
          }}
        />

        <DetailButtonSection onClose={onClose} onSave={handleSave} />
      </div>
    </SlideRightDialog>
  );
};

export default Type1;
